import css from './Burger.module.css';
import {scroller } from 'react-scroll';
import React, { useContext } from 'react';
import { MyContext } from '../MyContextProvider/MyContextProvider';
import pmg from './img/pmg.png';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

const Burger = () => {
  const { modal, setModal } = useContext(MyContext);
  const location = useLocation();
  const navigate = useNavigate();

  // 🔹 Универсальная функция перехода и скролла
  const handleScrollOrNavigate = (targetId, offset = 0) => (e) => {
    e.preventDefault();
    setModal(false);

    const scrollToSection = () => {
      scroller.scrollTo(targetId, {
        smooth: true,
        offset,
        duration: 1000,
      });
    };

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(scrollToSection, 400);
    } else {
      scrollToSection();
    }
  };

  return (
    <>
      {modal && (
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          className={css.container}
        >
          <nav className={css.nav}>
            <a href="#heroDesc" className={css.link} onClick={handleScrollOrNavigate('heroDesc', -250)}>
              О нас
            </a>
            <a href="#work" className={css.link} onClick={handleScrollOrNavigate('work', -150)}>
              Roadmap
            </a>
            <a
              href="#primer"
              className={`${css.link} ${css.nm}`}
              onClick={handleScrollOrNavigate('primer', -80)}
            >
              Примеры работ
            </a>
            <a
              href="#complects"
              className={css.link}
              onClick={handleScrollOrNavigate('complects', 50)}
            >
              Комплекты
            </a>
            <a
              href="#contacts"
              className={css.link}
              onClick={handleScrollOrNavigate('contacts', 50)}
            >
              Контакты
            </a>

            <a href="/documentation" className={css.link}>
              Документация
            </a>

            <a className={css.link} href="tel:+74997148164">
              +7 (499) 714-81-64
            </a>
          </nav>

          <div className={css.x} onClick={() => setModal(false)}>
            <img className={css.img} src={pmg} />
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Burger;
